module.exports = __webpack_public_path__ + "static/media/face2.c611f5f9.jpg";